
import classNames from 'classnames';
import { Container } from 'reactstrap';
import NavBar from './Navbar2';
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import {FirebaseDB} from "../../FirebaseDB"


import {
  ScrollView
} from 'react-native';


// import { Link, useNavigate } from "react-router-dom";
// import { auth, logInWithEmailAndPassword,logout, signInWithGoogle } from "./firebase";

import { withTranslation } from 'react-i18next';

class FeaturesCom extends React.Component {

  

  constructor(props) {
    super(props);

    this.state = {
//        login : Login
    }

    this.previousWidth = -1;
  }

  render() {
    
    const { t } = this.props;

    return (
      
      <Container  fluid className={classNames('content', { 'is-open': this.props.isOpen })}>
        
        {/* <NavBar toggle={this.props.toggle} /> */}

        {/* <LoginContext.login></LoginContext.login> */}
        
        <h3>
          {t("realtime")}
          
        </h3>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/2.jpg'/>
        {/* <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/features1-1.png'/> */}
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/features1-3.jpg'/>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/features1-4.jpg'/>
        <h3>
        {t("recording")}
        </h3>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="180"  src='./img/howto2-1.jpg'/>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/features1-2.png'/>

        <h3>
        
        {t("getting")}
          
        </h3>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="180"  src='./img/event1.jpg'/>
        <img style={{ marginBottom : 60,marginRight : 20}} height="360" width="360"  src='./img/features3.png'/>

        <h3>
        {t("suppoted")}
            
        </h3>


        <img style={{ marginBottom : 60,marginRight : 20}}   src='./img/features4.png'/>




      </Container>

   
    );
  }
}




export default withTranslation()(FeaturesCom);
